import React, { Component } from 'react'
import { Container} from 'reactstrap';
import SubHeader from './accurence_subheader';
import AccurenceTable from './accurence_table';
import AccurenceModel from 'shared/components/Models/accurence_model';
import DeleteConfirmationModel from 'shared/components/Models/delete_confirmation_model';
import simpleReactValidator from 'simple-react-validator';
import { connect } from 'react-redux';
import AlertSuccess from 'shared/components/Alerts/alert_success';
import {fetchFrequencyList,deleteFrequency,getFrequencyByid,addNewFrequency,editFrequencyData,checkExistFrequency} from 'shared/actions/frequency_action';
import {fetchStatusList,fetchOccurenceList} from 'shared/actions/actions';
import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';


class Accurence extends Component {
  constructor(props) {
    super(props)
    this.validator = new simpleReactValidator();
    this.state={
      modal: false,
      frequency_default_data:[],
      show_alert:false,
      del_frequency_id:0,
      lte:0,
      blocking:false,
      visible: true,
      check_exist:false,
      check_exist_message:false,
      current_name:""
    }
    this.toggle = this.toggle.bind(this);
    this.delete_toggle = this.delete_toggle.bind(this);
    this.onSubmit=this.onSubmit.bind(this);
    this.txtOnchange=this.txtOnchange.bind(this);
    this.onDismiss = this.onDismiss.bind(this);
    this.checkExist=this.checkExist.bind(this);
  }

  componentDidMount() {
    const { dispatch,frequency_data_by_id} = this.props
    dispatch(fetchFrequencyList())
    dispatch(fetchStatusList())
    dispatch(fetchOccurenceList())
    this.setState({
      blocking:!this.state.blocking
    })
  }

  onDismiss() {
    this.setState({ visible: false });
  }

  toggle() {
    this.validator.hideMessages();
    console.log("toogle");
    this.setState({
      frequency_default_data:[{id:"0",name:"",description:"",occur_frequency:"",occurrence_type:"",occur_schedule_config:"",status:1}],
      modal: !this.state.modal
    });
  }

  delete_toggle=(e)=>{
    this.setState({
      del_frequency_id:e,
      delete_model: !this.state.delete_model
    });
  }

  confim_delete=(e)=>{

    if(this.state.del_frequency_id>0)
    {
       this.props.dispatch(deleteFrequency(this.state.del_frequency_id))
       this.setState({
        del_frequency_id:0,
        delete_model: !this.state.delete_model,
        blocking:!this.state.blocking
      }); 
    } 
   
  }

  checkExist=(e)=>{
    var value=e.target.value;
    if(value!=""){
      if(this.state.current_name!=value){
        this.props.dispatch(checkExistFrequency(value));
      }
      
    }
    //console.log(value);
  }

  txtOnchange=(e)=>{
    var that=this;
    var id=e.target.id;
    id=id.split("-");
    var value=e.target.value;
    //console.log(value);
    if(id[0]=="occurrence_type"){
      if(value!=undefined){
        var state_val=0;
          if(value==1){
            state_val=1
          }
          if(value==2){
            state_val=3
          }
          if(value==3){
            state_val=12
          }
          that.setState({
            lte:state_val
          })
      }
      console.log(this.state.lte);
    }
    var accurence = that.state.frequency_default_data.filter(function(item) { 
      if(item.id == id[1])
      {
        item[id[0]]=value;
      }
       return item
    });
    that.setState({frequency_default_data:accurence});
  }

  bun_edit_click=(e)=>{
    this.validator.hideMessages();
    var that=this;
    if(e>0)
    {
      that.props.dispatch(getFrequencyByid(e))
      that.setState({
        modal: !that.state.modal
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    
    
        if(prevProps.frequency_data_by_id!=this.props.frequency_data_by_id){
          console.log("set data");
          var fac_data=this.props.frequency_data_by_id[0].occurrence_type;
          var state_val=0;
          if(fac_data==1){
            state_val=4
          }
          if(fac_data==2){
            state_val=3
          }
          if(fac_data==3){
            state_val=12
          }

          var name=this.props.frequency_data_by_id[0].name;
          var fdata=this.props.frequency_data_by_id;

          var freq_arrary=[{id:fdata[0].id,name:fdata[0].name,description:fdata[0].description,occur_frequency:fdata[0].occur_frequency.toString(),occurrence_type:fdata[0].occurrence_type,occur_schedule_config:fdata[0].occur_schedule_config,status:fdata[0].status,periodical_count:fdata[0].periodical_count}];
          
          

          this.setState({current_name:name, frequency_default_data: freq_arrary, lte:state_val });
          
        }

        if(prevProps.check_frequency!=this.props.check_frequency){
          if(this.props.check_frequency.success==true){
            this.setState({
              check_exist:true,
              check_exist_message:true
            })
          }
          else
          {
            this.setState({
              check_exist:false,
              check_exist_message:false
            })
          }
         
        }

        if((this.props.frequency_create_response!=prevProps.frequency_create_response) || (this.props.frequency_delete_data!=prevProps.frequency_delete_data))
        {
          this.setState({visible:true})
          this.props.dispatch(fetchFrequencyList())
        }
        if(prevProps.frequency_data!=this.props.frequency_data)
        {
          this.setState({
            blocking:false
          })
        }
    }
  


  onSubmit()
  {
     console.log(this.state.frequency_default_data);
     var that=this;
      if( that.validator.fieldValid("name")  && that.validator.fieldValid("description") &&that.validator.fieldValid("occurrence_type") && that.validator.fieldValid("occur_frequency")  && that.validator.fieldValid("status") )
      {
        var f_name=this.state.frequency_default_data[0].name;
        if(this.state.check_exist===false || (this.state.current_name==f_name)){
        var frequency_array=this.state.frequency_default_data;
        var id=frequency_array[0].id;
        if(id>0)
        {
          console.log("Update here");
          this.props.dispatch(editFrequencyData(frequency_array))
          this.setState({
            frequency_default_data:[{id:"0",name:"",description:"",occur_frequency:"",occurrence_type:"",occur_schedule_config:"",status:1}],
            modal: !this.state.modal,
            blocking:!this.state.blocking,
            check_exist:false,
            check_exist_message:false
          });
          
        }
        else
        {
          console.log("create here");
          this.props.dispatch(addNewFrequency(frequency_array))
          this.setState({
            frequency_default_data:[{id:"0",name:"",description:"",occur_frequency:"",occurrence_type:"",occur_schedule_config:"",status:1}],
            modal: !this.state.modal,
            blocking:!this.state.blocking,
            check_exist:false,
            check_exist_message:false
          }); 
        }
      }
      }
      else
      {
        console.log("validation fail");
        that.validator.showMessages();
        that.forceUpdate();
      }
  }

  render() {
    const { frequency_data,frequency_delete_data,frequency_data_by_id,frequency_create_response,status_list,occurence_data} = this.props


    return (
      <BlockUi tag="div" blocking={this.state.blocking}>
        <Container fluid={true}>
          <div className="pm-page-card">
            <div className="pm-page-card__header">
              <SubHeader toggle={this.toggle}/>
            </div>
            <div className="pm-page-card__body">
              {frequency_delete_data!=null && frequency_delete_data!=""?frequency_delete_data.success==true?<AlertSuccess visible={this.state.visible} onDismiss={this.onDismiss} color={"success"} alertText={frequency_delete_data.message}/>:<AlertSuccess visible={this.state.visible} onDismiss={this.onDismiss} color={"danger"} alertText={frequency_delete_data.message}/>:''}
              {frequency_create_response!=null && frequency_create_response!=""?frequency_create_response.success==true?<AlertSuccess visible={this.state.visible} onDismiss={this.onDismiss} color={"success"} alertText={frequency_create_response.message}/>:<AlertSuccess visible={this.state.visible} onDismiss={this.onDismiss} color={"danger"} alertText={frequency_create_response.message}/>:''}
              <AccurenceTable delete_toggle={this.delete_toggle} toggle={this.toggle} data={frequency_data} edit_click={this.bun_edit_click}/>
            </div>
          </div>
        </Container>
        <AccurenceModel check_exist_message={this.state.check_exist_message} onBlur={this.checkExist} lte={this.state.lte} occurence_data={occurence_data} validator={this.validator} onSubmitClick={this.onSubmit} isOpen={this.state.modal} toggle={this.toggle} status_data={status_list} frequency_default_data={this.state.frequency_default_data} onChange={this.txtOnchange}/>
        <DeleteConfirmationModel isDeleteOpen={this.state.delete_model} delete_toggle={this.delete_toggle} delete_yes_toggle={this.confim_delete}/>
      </BlockUi>
    )
  }
}

function mapStateToProps(state) {
var that=this;

  const {postsBySubreddit} = state
  const {
    frequency_data:frequency_data,
    frequency_delete_data:frequency_delete_data,
    frequency_data_by_id:frequency_data_by_id,
    frequency_create_response:frequency_create_response,
    status_list:status_list,
    occurence_data:occurence_data,
    check_frequency:check_frequency
  } =  postsBySubreddit 
  
  return {
    frequency_data,
    frequency_delete_data,
    frequency_data_by_id,
    frequency_create_response,
    status_list,
    occurence_data,
    check_frequency
  }
}


const AppContainer = connect(  
  mapStateToProps
)(Accurence);

export default AppContainer;



// WEBPACK FOOTER //
// ./src/shared/containers/Accurence/index.js